import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';

const pageSchema = GatewayGetSchema.pages.customFields;
const pageId = pageSchema.pageId;

function GatewayCustomFields({
    gatewayObject,
    setGatewayData
}) {
    const pageData = gatewayObject[pageId];

    const customFieldOne = pageData[pageSchema.customFieldOne];
    const customFieldTwo = pageData[pageSchema.customFieldTwo];
    
    const customFieldSchema = pageSchema.customFieldSchema;

    return (
        <EditorLayout>
            {
                customFieldOne && (
                    <SMCTextInput
                        value={customFieldOne[customFieldSchema.value]}
                        onChange={e => setGatewayData([pageId, pageSchema.customFieldOne, customFieldSchema.value], e.target.value)}
                        label={customFieldOne[customFieldSchema.name]}
                    />
                )
            }
            {
                customFieldTwo && (
                    <SMCTextInput
                        value={customFieldTwo[customFieldSchema.value]}
                        onChange={e => setGatewayData([pageId, pageSchema.customFieldTwo, customFieldSchema.value], e.target.value)}
                        label={customFieldTwo[customFieldSchema.name]}
                    />
                )
            }
        </EditorLayout>
    )
}

export default GatewayCustomFields;